import { ContactRole, SubscriptionAction } from '../../generated/api/models.js';
import { paths } from '../constants/pathVariables.js';
import { SubscriptionCategory } from '../enums.js';
import type { SubscriptionActionSearchResponse } from '../../generated/api/models.js';
import type { AuthenticatedUser } from '../../public/site/authState';
import type { ActionsHistory } from '../../selfservice/common/store.js';

export const getSubCategoryFromPath = (path: string) => {
  const pathname = decodeURI(path);
  const isEmployeeSubscriptionsOrVoice =
    pathname.startsWith(paths.EMPLOYEE_SUBSCRIPTIONS) || pathname.startsWith(paths.EMPLOYEE_VOICE_SUBSCRIPTIONS);
  const isBroadband = pathname.startsWith(paths.EMPLOYEE_BROADBAND_SUBSCRIPTIONS);

  if (isEmployeeSubscriptionsOrVoice) {
    return SubscriptionCategory.VOICE;
  } else if (isBroadband) {
    return SubscriptionCategory.BROADBAND;
  } else {
    return SubscriptionCategory.DEVICE;
  }
};

export const getFilteredSubscriptionActions = (subscriptionActions: SubscriptionActionSearchResponse[]) => {
  const eppRedeemTerminate = SubscriptionAction.SubscriptionActionTypeEnum.EPP_REDEEM_TERMINATE;
  return subscriptionActions?.filter(e => e.result.subscriptionActionType === eppRedeemTerminate);
};

export const hasSubscriptionActionsPendingForApproval = (subActions: SubscriptionActionSearchResponse[]): boolean => {
  const filtered = getFilteredSubscriptionActions(subActions);
  const pendingApproval = filtered.filter(e => e.result.status === SubscriptionAction.StatusEnum.PENDING_APPROVAL);
  return pendingApproval.length > 0;
};

export const userHasEmptyOrSMEPriceGroup = (segmentPricingGroup?: string) =>
  !segmentPricingGroup || segmentPricingGroup.toLowerCase() === 'sme pricing group';

export const userHasApproverRole = (authenticated: (AuthenticatedUser & ActionsHistory) | null | undefined): boolean =>
  Boolean(authenticated?.contact?.person?.roles?.includes(ContactRole.APPROVER));
